'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.FoerderungSchema = {
  title: 'Foerderung',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/foerderung.js
// module id = OhRX
// module chunks = 0